import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { TypesDeleteModal } from './TypeDelete';
// import styles from './ImportTubeChartModalStyle.module.scss';
import ScreenTubeChartLibrary from '../../Screens/tubeChartLibrary/ScreenTubeChartLibrary';
import { Cancel } from '../../media/images/Cancel';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '85%',
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '20px',
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
export default function ImportTubeChartModal({ show, setOpenFrom }: TypesDeleteModal): JSX.Element {
  return (
    <Modal
      open={show}
      onClose={() => {}}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            TUBE CHART LIBRARY
          </div>
          <div className="cancel-icon pointer" onClick={() => setOpenFrom()}>
            <Cancel />
          </div>

        </div>
        <ScreenTubeChartLibrary />
      </Box>
    </Modal>
  );
}
